export default __webpack_public_path__ + "static/media/standinbgTableBgDec.34ffb8c4.png";